module.exports = __webpack_public_path__ + "static/img/ad_for_out_new.89943cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad_for_out_new.png
// module id = Sm5E
// module chunks = 2